import {useEffect} from "react";
import {useLocation} from "react-router-dom";
import {useAtomValue} from "jotai";
import {authenticatedUserLoadable} from "../store/authenticatedUserStore";
import analytics from "../services/analyticsService";
import {swallowException} from "../utils/appUtils";

/**
 * Hook for Analytics initialization
 */
export const useAnalyticsInit = () => {
    const location = useLocation();
    const authenticatedUserState = useAtomValue(authenticatedUserLoadable);

    // Analytics: Identify a user
    useEffect(() => {
        if (authenticatedUserState.state === "hasData") {
            const user = authenticatedUserState.data;
            analytics
                .identify(user.id, {
                    email: user.properties.email,
                    userId: user.id,
                    firstName: user.properties.firstName,
                    lastName: user.properties.lastName,
                })
                .catch(swallowException);
        }
    }, [authenticatedUserState]);

    // Analytics: Track a page view
    useEffect(() => {
        analytics.page().catch(swallowException);
    }, [location]);
};
